import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CopyLink from '../common/CopyLink';
import ShareResource from '../ShareResource';

class SharesTable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      csrfToken, project, shareOptions, recipientOptions, triggerType,
    } = this.props;

    return (
      <div className="project-proposals-container shares-container box-shadow-1 style-guide">
        { project.shares.length === 0
          ? <div className="shares-empty-header">There are no shares for this project.</div>
          : (
            <table className="shares-table table">
              <tbody>
                <tr>
                  <th>Source</th>
                  <th>Views</th>
                  <th>Action</th>
                </tr>
                { project.shares.map((shareObject) => (
                  <tr>
                    <td>{ shareObject.candidate_source }</td>
                    <td>{ shareObject.views }</td>
                    <td>
                      <CopyLink
                        url={shareObject.url}
                        shortForm
                        linkText={shareObject.copy_link_text}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        <ShareResource
          generateUrl={`/projects/${project.resource_id}/generate_shareable_link`}
          csrfToken={csrfToken}
          resourceId={project.resource_id}
          triggerType={triggerType}
          triggerText="Share Project"
          idKey="share-project-modal"
          resourceType="Project"
          buttonStyles="primary"
          sourceOptions={shareOptions}
          recipientOptions={recipientOptions}
          className="primary btn btn-primary full-width share-project-button"
          id="share-project"
        />
      </div>
    );
  }
}

SharesTable.propTypes = {
  project: PropTypes.shape({}).isRequired,
  csrfToken: PropTypes.string.isRequired,
  shareOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  recipientOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  triggerType: PropTypes.string,
};

SharesTable.defaultProps = {
  triggerType: 'link',
};

export default SharesTable;
